import * as React from 'react';

import AppStoreLinks from 'components/app-store-links/AppStoreLinks';

import { __t, applyTranslations } from 'utils/language';

import './app-store.scss';

applyTranslations(require('./app-store.i18n.json'));

const MSG_KEY = 'app_store';

const AppStore = (): JSX.Element => (
  <div className="app-store">
    <div className="app-store__heading">
      {__t(`${MSG_KEY}.main_text`)}
    </div>
    <div className="app-store__body">
      {__t(`${MSG_KEY}.body_text`)}
    </div>
    <div className="app-store__links">
      <AppStoreLinks />
    </div>
  </div>
);

export default AppStore;
